import { render } from "./WisePage.vue?vue&type=template&id=671167b4&scoped=true"
import script from "./WisePage.vue?vue&type=script&lang=js"
export * from "./WisePage.vue?vue&type=script&lang=js"

import "./WisePage.vue?vue&type=style&index=0&id=671167b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671167b4"]])

export default __exports__